import {api} from "../../common/config/api";

export const USER_URL = {
   login:`${api.withAPI}/v1/admin/login`,
   refresh_token:`${api.withAPI}/v1/admin/refresh`,
   logout:`${api.withAPI}/v1/admin/logout`
}
